import React, {Component} from 'react';
import {Button, Spin} from 'antd';

class AssetName extends Component {
  constructor(props) {
    super(props);
    this.state = {
      assetObj: {},
    }
  }

  componentDidMount() {
    // const {asset} = this.props;
    // if(asset) {
    //   let id = asset;
    //   if(typeof asset === "object" && asset._id)
    //     id = asset && asset._id;
    //   this.props.assetSearch(id, 'Asset', '_id');
    // }
  }

  componentWillUpdate(nextProps, nextState) {
    // console.log(nextProps.assetData, '====', this.props.assetData)
    if(nextProps.assetData && nextProps.assetData.length > 0) {
      if(nextProps.assetData && nextProps.assetData !== this.props.assetData) {
        let oldAssetObj = this.state.assetObj;

        oldAssetObj[nextProps.assetData[0]._id] = nextProps.assetData[0];
        this.setState({
          assetObj: oldAssetObj
        })
      }
    }
  }

  handelClick = (assetId) => {
    const {match} = this.props;
    if(assetId)
      this.props.history.push(`/asset/history-report/${assetId}`);
  }

  render() {
    const {loading, assetData, asset} = this.props;
    //const {assetObj} = this.state;
    //console.log(assetObj);
    return (
      <div>
        {
          !loading ?
            asset && asset._id ? <Button type={'link'}
                                                             onClick={() => this.handelClick(asset._id)}>{asset.assetCode}</Button> : 'NA' :
            <Spin size="small"/>
        }
      </div>
    );
  }
}

export default AssetName;
